import React from "react"
import { useShallow } from "zustand/react/shallow"

// components
import { Tooltip } from "antd"
import useRegistryBadges from "containers/studies/Study/subcomponents/Authoring/RJS/components/Badges/useRegistryBadges/useRegistryBadges"
import ForkDeleteModal from "containers/studies/Study/subcomponents/Authoring/RJS/components/ForkDeleteModal"
import DeleteForkSvg from "containers/studies/Study/subcomponents/Authoring/assets/DeleteForkSvg"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"
import useAuthoringDataStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringDataStore"

// styles
import "./TableForkActions.scss"

const TableForkActions = ({ registry, isFork, jpath, style = {}, deleteForkCallback = () => {} }) => {
  const { getBadges } = useRegistryBadges()
  const [openDeleteForkedModal, setOpenDeleteForkedModal] = React.useState(false)

  const { readOnly } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      formView: state.formView,
    }))
  )

  const { forkedStudyData, setForkedStudyData } = useAuthoringDataStore(
    useShallow((state) => ({
      forkedStudyData: state.forkedStudyData,
      setForkedStudyData: state.setForkedStudyData,
    }))
  )

  const onDeleteForkField = () => {
    let tempForkedFields = { ...forkedStudyData }
    delete tempForkedFields[registry][jpath]
    setForkedStudyData(tempForkedFields)
    setOpenDeleteForkedModal(false)
    deleteForkCallback({ registry, jpath })
  }

  return (
    <div
      className="table-fork-actions"
      style={style}
    >
      {getBadges([registry])}
      {isFork && readOnly !== true && (
        <Tooltip title={`Remove ${registry.toUpperCase()} forked field`}>
          <span className="delete-fork-wrapper">
            <DeleteForkSvg onClick={() => setOpenDeleteForkedModal(true)} />
          </span>
        </Tooltip>
      )}
      <ForkDeleteModal
        onHide={() => setOpenDeleteForkedModal(false)}
        showModal={openDeleteForkedModal}
        onSubmit={onDeleteForkField}
      />
    </div>
  )
}

export default TableForkActions
